exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".active-shift[data-v-7c6c8faa]{background-color:#4da6a1!important;-webkit-box-shadow:0 5px 15px rgba(0,0,0,.3);box-shadow:0 5px 15px rgba(0,0,0,.3);color:#fff}", "", {"version":3,"sources":["/app/src/components/Attendance.vue"],"names":[],"mappings":"AACA,+BACE,mCAAqC,AACrC,6CAA+C,AACvC,qCAAuC,AAC/C,UAAa,CACd","file":"Attendance.vue","sourcesContent":["\n.active-shift[data-v-7c6c8faa] {\n  background-color: #4DA6A1 !important;\n  -webkit-box-shadow: 0 5px 15px rgba(0,0,0,0.3);\n          box-shadow: 0 5px 15px rgba(0,0,0,0.3); /* similar to elevation-10 */\n  color: white; /* optional, for text contrast */\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":{"safe":true,"reduceIdents":false,"zindex":false,"mergeRules":false,"discardComments":{"removeAll":true}},"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7c6c8faa","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Attendance.vue
// module id = 878
// module chunks = 6